import classNames from "classnames";
import React from "react";

interface IParams {
  isFullscreen: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className: string;
}

const ThumbnailBarButton: React.FC<IParams> = ({
  isFullscreen,
  onClick,
  className,
}) => {
  
  return (
    <>
      <button
        className={classNames(
          className,
          `${isFullscreen ? "thumbnailButtonFullscreen" : "thumbnailButton"}`
        )}
        onClick={onClick}
      >
        <i className="fas fa-ellipsis-h fa-2x customIconBorder"></i>
      </button>
    </>
  );
};

export default ThumbnailBarButton;
